import * as i18n from 'i18next';

export { i18n };
export { default } from 'i18next';
export { Trans, useTranslation } from 'react-i18next';
